/* Aeshal — cart UX helpers (audit fixes, 2026-07-10)
 * 1) Header cart count bubble, kept in sync via Pipeline's cart events.
 * 2) After a successful add-to-cart, open the cart drawer; if the drawer
 *    isn't usable, show an "Added to your bag" toast instead.
 * 3) Clamp quantity steppers to the input's max attribute — Pipeline's
 *    stepper ignores it, letting shoppers exceed 1-of-1 stock.
 */
(function () {
  var lastAtc = 0;

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-add-to-cart]')) {
      lastAtc = Date.now();
    }
  }, true);

  /* --- 3: quantity clamp ------------------------------------ */
  function clampQty(input) {
    if (!input || !input.matches || !input.matches('[data-quantity-input]')) return;
    var max = parseInt(input.max, 10);
    var val = parseInt(input.value, 10);
    if (!isNaN(max) && max > 0 && !isNaN(val) && val > max) {
      input.value = max;
    }
  }

  document.addEventListener('change', function (e) { clampQty(e.target); }, true);
  document.addEventListener('input', function (e) { clampQty(e.target); }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-increase-quantity]');
    if (!btn) return;
    var wrap = btn.closest('[data-quantity-selector]');
    var input = wrap && wrap.querySelector('[data-quantity-input]');
    if (!input) return;
    setTimeout(function () {
      clampQty(input);
    }, 0);
  });

  /* --- 1: count bubble --------------------------------------- */
  function bubbles(count) {
    document.querySelectorAll('[data-drawer-toggle="drawer-cart"]').forEach(function (link) {
      var b = link.querySelector('.aes-cart-count');
      if (!b) {
        b = document.createElement('span');
        b.className = 'aes-cart-count';
        b.setAttribute('aria-hidden', 'true');
        link.appendChild(b);
      }
      b.textContent = count > 99 ? '99+' : String(count);
      b.classList.toggle('is-empty', !count);
    });
  }

  function seedFromDom() {
    var el = document.querySelector('[data-header-cart-count]');
    var n = el ? parseInt(el.getAttribute('data-header-cart-count'), 10) : 0;
    bubbles(isNaN(n) ? 0 : n);
  }

  /* --- 2: post-add feedback ---------------------------------- */
  function drawerVisible() {
    var d = document.querySelector('[data-drawer="drawer-cart"]');
    if (!d) return false;
    var r = d.getBoundingClientRect();
    var cs = window.getComputedStyle(d);
    return cs.visibility !== 'hidden' && r.width > 0 && r.width < window.innerWidth * 0.9 && r.height > 200 && r.top < window.innerHeight * 0.5;
  }

  function toast() {
    var t = document.querySelector('.aes-add-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'aes-add-toast';
      t.innerHTML = 'Added to your bag <a href="/cart">View bag</a>';
      document.body.appendChild(t);
    }
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    clearTimeout(t._aesTimer);
    t._aesTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 4500);
  }

  function onCart(e) {
    var cart = e.detail && e.detail.cart;
    if (cart && typeof cart.item_count !== 'undefined') bubbles(cart.item_count);
    else seedFromDom();

    if (e.type === 'theme:cart:change' && lastAtc && Date.now() - lastAtc < 5000) {
      lastAtc = 0;
      if (!drawerVisible()) {
        var toggle = document.querySelector('[data-drawer-toggle="drawer-cart"]');
        if (toggle) toggle.click();
        setTimeout(function () { if (!drawerVisible()) toast(); }, 450);
      }
    }
  }

  document.addEventListener('theme:cart:init', onCart);
  document.addEventListener('theme:cart:change', onCart);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', seedFromDom);
  } else {
    seedFromDom();
  }
})();
